module.exports = "/lucky-balls/img/regular_game/hole.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/hole.png
// module id = 1152
// module chunks = 0